<div class="wrapper" *ngIf="datafeed">
	<bb-form-element *ngIf="datafeed.feedType === 'renderedVideo'" [form]="form" [label]="'DYNAMIC_VIDEO_CLIP' | translate">
		<!-- [filterSet]="dynamicVideoFilterSet" -->
		<bb-entity-selector [entityType]="'mediaclip'" [(ngModel)]="datafeed.dynamicMediaclip" name="dynamicMediaclip" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>

	<bb-form-element *ngIf="datafeed.feedType === 'renderedVideo'" [form]="form" [label]="'AFTER_EFFECTS_PROJECT_FILES' | translate">
		<bb-entity-selector [entityType]="'mediaclip'" [(ngModel)]="datafeed.dynamicVideoProject" name="dynamicVideoProject" (ngModelChange)="datafeedChanged(datafeed)" [filterSet]="[{
			filters: [{
				type: 'mediaclip',
				field: 'mediatype',
				operator: 'is',
				value: 'document'
			}]
		}]"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'xmlUploadImport'" [label]="'EXAMPLE_IMPORT_XML' | translate">
		<input type="file" name="exampleXML-file-input" [(ngModel)]="exampleXMLFile" [ngModelOptions]="{standalone: true}" (change)="exampleXMLFileChange($event)" />
		<bb-code-editor [editorConfig]="{language: 'html'}" [(ngModel)]="datafeed.exampleXML" name="exampleXML" placeholder="Example XML" (ngModelChange)="exampleXMLChanged(datafeed.exampleXML)"></bb-code-editor>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'xmlUploadImport'" [label]="'XSL_FOR_MAPPING' | translate">
		<input type="file" name="xsl-file-input" [(ngModel)]="xmlImportXslFile" [ngModelOptions]="{standalone: true}" (change)="xslFileChanged($event)" />
		<bb-code-editor [editorConfig]="{language: 'html'}" [(ngModel)]="datafeed.xsl" name="xmlImportXsl" placeholder="Optional XSL to use for field mapping."></bb-code-editor>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'renderedVideo'" [label]="'AFTER_EFFECTS_XML' | translate">
		<input type="file" name="ae-file-input" [(ngModel)]="aeFile" [ngModelOptions]="{standalone: true}" (change)="aeFileChange($event)" />
	</bb-form-element>

	<bb-form-element *ngIf="datafeed.feedType === 'renderedVideo'" [form]="form" [label]="'COMPOSITION_TO_RENDER' | translate">
		<input matInput [matAutocomplete]="compositionToRenderAuto" type="text" name="composition-to-render" [(ngModel)]="datafeed.compositionToRender" />
		<mat-autocomplete #compositionToRenderAuto="matAutocomplete">
			<mat-option *ngFor="let option of aeProject.compositionOptions" [value]="option.value">{{option.label}}</mat-option>
		</mat-autocomplete>
	</bb-form-element>

	<bb-form-element *ngIf="datafeed.feedType === 'default'" [label]="'USE_CONDITIONS' | translate" [form]="form">
		<bb-check [(ngModel)]="datafeed.useConditions" name="useConditions" (ngModelChange)="onUseConditionsChange($event)"></bb-check>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.useConditions" [form]="form" [label]="'RANDOM_ROW_SELECTION' | translate" [helpMessage]="'HELP.RANDOM_ROW_SELECTION' | translate">
		<bb-check [(ngModel)]="datafeed.randomRowSelection" name="randomRowSelection" (ngModelChange)="datafeedChanged(datafeed)"></bb-check>
	</bb-form-element>

	<bb-form-element *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport' && !fieldConfiguration?.isImport" [label]="'SPREADSHEET_IMPORT' | translate">
		<input type="file" name="file-input" [(ngModel)]="selectedFile" [ngModelOptions]="{standalone: true}" (change)="fileChange($event)" (ngModelChange)="datafeedChanged(datafeed)" />
	</bb-form-element>

	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport'" [label]="'RSS_FEED_URL' | translate" [form]="form">
		<input type="text" name="rss-url" [(ngModel)]="datafeed.rssUrl" (change)="onRssUrlChange(datafeed.rssUrl)" (ngModelChange)="datafeedChanged(datafeed)" />
		
		<div class="message warning" *ngIf="xmlproxyFetchError">
			Warning: Failed to fetch the feed URL through our XML proxy.
		</div>
		<ng-container *ngIf="parseErrorHtml && !xmlproxyFetchError">
			<div class="message warning">
				Warning: There are <span class="error-toggle" (click)="showRssErrors = !showRssErrors">errors</span> in the RSS feed document. This might result in the feed not working correctly. Please contact the supplier of the feed if this is the case.
			</div>
			<div class="error-html" [hidden]="!showRssErrors">
				<pre [innerHTML]="parseErrorHtml"></pre>
			</div>
		</ng-container>
	</bb-form-element>
	
	<bb-form-element *ngIf="!parseErrorHtml && datafeed.feedType === 'rssFeedImport' && datafeed.rssUrl" [label]="'RSS_XML_ITEM_NODE_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemNodePath" [extendable]="true" [options]="xmlNodeOptions" name="rssItemNodePath" (ngModelChange)="onRssItemNodePathChange(datafeed.rssItemNodePath)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'xmlUploadImport'" [label]="'XML_ITEM_NODE_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.xmlItemNodePath" [extendable]="true" [options]="xmlNodeOptions" name="xmlItemNodePath" (ngModelChange)="onXmlItemNodePathChange(datafeed.xmlItemNodePath)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="!parseErrorHtml && datafeed.feedType === 'rssFeedImport' && datafeed.rssUrl" [label]="'RSS_XML_UPDATE_CHECK_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssUpdateCheckPath" [extendable]="true" [options]="xmlAllNodeOptions" name="rssUpdateCheckPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
		
	<bb-form-element *ngIf="datafeed.feedType === 'xmlUploadImport' && datafeed.xmlItemNodePath" [label]="'XML_THUMBNAIL_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.itemThumbnailPath" [extendable]="true" [options]="xmlItemNodeOptions" name="itemThumbnailPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>

	<h3 *ngIf="datafeed.rssItemNodePath">{{ 'RSS_ITEM_PROPERTY_PATHS' | translate }}</h3>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_ID_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemIDPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemIDPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_VIDEO_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemVideoPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemVideoPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_VIDEO_WIDTH_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemVideoWidthPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemVideoWidthPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_VIDEO_HEIGHT_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemVideoHeightPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemVideoHeightPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_THUMBNAIL_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemThumbnailPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemThumbnailPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_THUMBNAIL_WIDTH_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemThumbnailWidthPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemThumbnailHeightPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>
	
	<bb-form-element *ngIf="datafeed.feedType === 'rssFeedImport' && datafeed.rssItemNodePath" [label]="'RSS_XML_ITEM_THUMBNAIL_HEIGHT_PATH' | translate" [form]="form">
		<bb-entity-selector [(ngModel)]="datafeed.rssItemThumbnailHeightPath" [extendable]="true" [options]="xmlItemNodeOptions" name="rssItemThumbnailHeightPath" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
	</bb-form-element>

	<bb-form-element *ngIf="datafeed.feedType === 'renderedVideo'" [label]="'STORE_ROWS_SEPARATELY' | translate" [form]="form">
		<bb-check [(ngModel)]="datafeed.storageMode" name="useConditions" trueValue="s3" falseValue="" (ngModelChange)="onStorageModeChange($event);datafeedChanged(datafeed)" [disabled]="true"></bb-check>
	</bb-form-element>

	
	<!-- 
	Renders a node structure tree, might use later
	<div class="rss-doc" *ngIf="rssItem || rssXmlDoc">
		<ul class="node-list">
			<ng-container *ngTemplateOutlet="nodeItem; context: {node: rssItem || rssXmlDoc}"></ng-container>
		</ul>
	</div>

	<ng-template #nodeItem let-node="node">
		<ng-container *ngIf="node">
			<ng-container *ngFor="let node of node.childNodes; let i = index;">
				<li *ngIf="!isEmptyNode(node)" class="node" (click)="$event.stopPropagation();openedNodes[ getPathTo(node) ] = true;log(node)">
					<ng-container *ngIf="node.nodeName === '#text' || node.nodeName === '#cdata-section'">
						<strong>{{ node.textContent }}</strong>
					</ng-container>
					<ng-container *ngIf="node.nodeName !== '#text' && node.nodeName !== '#cdata-section'">
						<i [style.display]="!openedNodes[ getPathTo(node) ] ? 'none' : 'inline'" class="fas fa-caret-down"></i>
						<i [style.display]="openedNodes[ getPathTo(node) ] ? 'none' : 'inline'" class="fas fa-caret-right"></i>
						&lt;{{ node.nodeName }}&gt;
						<li *ngIf="node.attributes?.length">
							<ng-container *ngFor="let attr of node.attributes; let attrIndex = index;">
								@{{ attr.nodeName }}
								<ng-container *ngTemplateOutlet="nodeItem; context: {node: attr}"></ng-container>
							</ng-container>
						</li>
					</ng-container>
					<ng-container *ngIf="openedNodes[ getPathTo(node) ] && node.childNodes">
						<ng-container *ngTemplateOutlet="nodeItem; context: {node: node}"></ng-container>
					</ng-container>
				</li>
			</ng-container>
		</ng-container>
	</ng-template>
	-->

	<div class="column-configuration" *ngIf="!parseErrorHtml && fieldConfiguration?.fields && !datafeed?.xsl">
		<h3>
			{{ (fieldConfiguration.isMapping ? 'MEDIACLIP_FIELD_MAPPING' : (fieldConfiguration.isImport ? 'IMPORT_DATA' : 'UPDATE_COLUMNS')) | translate }}
		</h3>

		<bb-form-element [label]="'SHEET_SELECTION' | translate" *ngIf="fieldConfiguration?.isImport">
			<bb-select [(ngModel)]="selectedSheet" [ngModelOptions]="{standalone: true}" [options]="sheetOptions" (ngModelChange)="onSheetSelected($event)"></bb-select>
		</bb-form-element>

		<bb-table-container>
			<bb-table-header>
				<bb-table-header-cell class="field-include" *ngIf="fieldConfiguration?.isImport">
					<span>Include</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-key">
					<span *ngIf="fieldConfiguration?.isImport">Source Key</span>
					<span *ngIf="!fieldConfiguration?.isImport && !fieldConfiguration?.isMapping">Key 
						<small>
							Warning: Changing the key will also change the data
						</small>
					</span>
					<span *ngIf="fieldConfiguration?.isMapping">
						Mediaclip Property
					</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-type" *ngIf="datafeed.useConditions">
					<span>Column type</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-key" *ngIf="fieldConfiguration?.isImport">
					<span>Target Key</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-xmlPath" *ngIf="datafeed.feedType === 'rssFeedImport' || datafeed.feedType === 'xmlUploadImport'">
					<span>XML item property path</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-label" *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport'">
					<span>Label</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-type" *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport'">
					<span>Field type</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-config" *ngIf="datafeed.feedType === 'renderedVideo'">
					<span>Rendered video configuration</span>
				</bb-table-header-cell>
				<bb-table-header-cell class="field-config" *ngIf="datafeed.feedType === 'rssFeedImport' || datafeed.feedType === 'xmlUploadImport'">
					<!-- actions -->
					&nbsp;
				</bb-table-header-cell>
			</bb-table-header>
	
			<ng-container *ngFor="let field of fieldConfiguration.fields; let colIndex = index;">
				<bb-table-row [row]="field" *ngIf="field.headerType !== 'addCondition' && field.headerType !== 'addValue'">
					<bb-table-cell *ngIf="fieldConfiguration?.isImport">
						<div class="cell-inner">
							<bb-check [(ngModel)]="field.include" name="include"></bb-check>
						</div>
					</bb-table-cell>
					<bb-table-cell>
						<div class="cell-inner" (dblclick)="clipEditMode = true;">
							<span *ngIf="fieldConfiguration?.isImport">{{ field.key }}</span>
							<input *ngIf="!fieldConfiguration?.isImport && !fieldConfiguration?.isMapping" [class.disabled]="field.key === 'id' || field.key === 'composition'" [disabled]="field.key === 'id' || field.key === 'composition'" type="text" [(ngModel)]="field.key" [name]="'field-key-' + i" pattern="^[a-z0-9_-]" (change)="onKeyChange(field.key, colIndex)" />
							<bb-entity-selector *ngIf="clipEditMode && fieldConfiguration?.isMapping" [(ngModel)]="field.key" [extendable]="true" [options]="mediaclipOptions" [name]="'field-key-' + i" ></bb-entity-selector>
							<span *ngIf="fieldConfiguration?.isMapping && !clipEditMode">{{ field.key | valueToLabel : mediaclipOptions }}</span>
						</div>
					</bb-table-cell>
					<bb-table-cell *ngIf="datafeed.useConditions">
						<div class="cell-inner">
							<bb-select [(ngModel)]="field.headerType">
								<option value="value">
									{{ 'VALUE' | translate }}
								</option>
								<option value="condition">
									{{ 'CONDITION' | translate }}
								</option>
							</bb-select>
						</div>
					</bb-table-cell>
					<bb-table-cell *ngIf="fieldConfiguration?.isImport">
						<div class="cell-inner">
							<input matInput [matAutocomplete]="auto" type="text" class="header-label" [(ngModel)]="field.targetKey" [name]="'field-value-' + i" pattern="^[a-z0-9_-]"/>
							<mat-autocomplete #auto="matAutocomplete">
								<mat-option *ngFor="let column of columnsByType[field.headerType]" [value]="column.key">{{column.key}}</mat-option>
							</mat-autocomplete>
						</div>
					</bb-table-cell>
					<bb-table-cell>
						<ng-container *ngIf="datafeed.feedType === 'rssFeedImport' || datafeed.feedType === 'xmlUploadImport'">
							<div class="cell-inner">
								<!-- <input type="text" class="field-xmlPath" [(ngModel)]="field.xmlPath" [ngModelOptions]="{standalone: true}" /> -->
								<bb-entity-selector [(ngModel)]="field.xmlPath" [extendable]="true" [options]="xmlItemNodeOptions" [name]="'field-xml-path-' + i" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
							</div>
						</ng-container>
						<ng-container *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport'">
							<div class="cell-inner">
								<input type="text" class="field-label" [(ngModel)]="field.label" [ngModelOptions]="{standalone: true}" />
							</div>
						</ng-container>
					</bb-table-cell>
					<bb-table-cell *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport'">
						<div class="cell-inner" *ngIf="!(datafeed.feedType === 'renderedVideo' && (field.headerType === 'id' || field.headerType === 'composition'))">
							<bb-select [(ngModel)]="field.dataType" [ngModelOptions]="{standalone: true}" [options]="fieldTypeOptions"></bb-select>
						</div>
					</bb-table-cell>
					<bb-table-cell> 
						<div class="cell-inner" *ngIf="datafeed.feedType === 'renderedVideo' && !(field.headerType === 'id' || field.headerType === 'composition')">
							<bb-form-element [label]="'COMPOSITION' | translate">
								<input matInput [matAutocomplete]="auto1" type="text" [(ngModel)]="field.composition" [name]="'aecomposition' + colIndex" />
								<mat-autocomplete #auto1="matAutocomplete">
									<mat-option *ngFor="let option of aeProject.compositionOptions" [value]="option.value">{{option.label}}</mat-option>
								</mat-autocomplete>
							</bb-form-element>
							<bb-form-element [label]="'LAYER' | translate" *ngIf="field.composition">
								<!-- With options: -->
								<ng-container *ngIf="aeProject.layerOptions && aeProject.layerOptions[field.composition]">
									<input matInput [matAutocomplete]="auto2" type="text" [(ngModel)]="field.layer" [name]="'aelayer' + colIndex" />
									<mat-autocomplete #auto2="matAutocomplete">
										<mat-option *ngFor="let option of aeProject.layerOptions[field.composition]" [value]="option.value">{{option.label}}</mat-option>
									</mat-autocomplete>
								</ng-container>
								<!-- Without options: -->
								<ng-container *ngIf="!aeProject.layerOptions || !aeProject.layerOptions[field.composition]">
									<input type="text" [(ngModel)]="field.layer" [name]="'aelayer' + colIndex" />
								</ng-container>
							</bb-form-element>
							<bb-form-element [label]="'DATA_TYPE' | translate" *ngIf="field.layer">
								<bb-select [(ngModel)]="field.aeDataType">
									<option value="video">
										{{ 'VIDEO' | translate }}
									</option>
									<option value="audio">
										{{ 'AUDIO' | translate }}
									</option>
									<option value="image">
										{{ 'IMAGE' | translate }}
									</option>
									<option value="data">
										{{ 'DATA' | translate }}
									</option>
								</bb-select>
							</bb-form-element>
							<ng-container *ngIf="field.layer && field.aeDataType === 'data'">
								<bb-form-element [label]="'PROPERTY' | translate">
									<input type="text" [(ngModel)]="field.layerProperty" [name]="'layerProperty' + colIndex" />
								</bb-form-element>
								<bb-form-element [label]="'IS_EXPRESSION' | translate">
									<bb-check [(ngModel)]="field.isExpression" name="isExpression"></bb-check>
								</bb-form-element>
							</ng-container>
						</div>
					</bb-table-cell>
					<bb-table-cell *ngIf="datafeed.feedType === 'rssFeedImport' || datafeed.feedType === 'xmlUploadImport'">
						<div class="cell-inner">
							<span class="remove-field" (click)="removeFieldmapping(colIndex)"><i class="fa fa-trash"></i></span>
						</div>
					</bb-table-cell>
				</bb-table-row>
			</ng-container>
	
		</bb-table-container>

		<div class="include-rows" *ngIf="fieldConfiguration?.rows">
			<bb-form-element [label]="(( fieldConfiguration?.isImport ? 'INCLUDE_ROWS' : 'UPDATE_ROWS') | translate ) + ' (' + fieldConfiguration?.rows?.length + ')'">
				<bb-check [(ngModel)]="fieldConfiguration.includeRows" name="public"></bb-check>
			</bb-form-element>
		</div>
		<div class="submit-wrapper">
			<ng-container *ngIf="fieldConfiguration?.isMapping">
				<bb-entity-selector [placeholder]="'Add property mapping'" [selectOnly]="true" class="add-mediaclip-property-selector" [(ngModel)]="addMediaclipProperty" [options]="mediaclipOptions" [ngModelOptions]="{standalone: true}" (optionSelected)="onMediaclipPropertyMappingSelected($event)" (ngModelChange)="datafeedChanged(datafeed)"></bb-entity-selector>
			</ng-container>
			
			<ng-container *ngIf="!fieldConfiguration?.isMapping">
				<bb-button class="cancel-button" (click)="clearConfiguration()">
				{{ 'CANCEL' | translate }}
			</bb-button>
			<bb-button [active]="true" class="submit-button" (click)="importData(fieldConfiguration, datafeed)">
				{{ (fieldConfiguration.isImport ? 'IMPORT' : 'UPDATE') | translate }}
			</bb-button>
			</ng-container>
		</div>
	</div>

	<!-- <bb-field-configuration [(ngModel)]="datafeed.columns" name="field_configuration"></bb-field-configuration> -->
	
	<div class="render-actions" *ngIf="datafeed.feedType === 'renderedVideo'" [class.disabled]="form?.form?.dirty">
		<span class="button" (click)="startRender()" [title]="'START_RENDERING' | translate">
			<i class="fa fa-cogs"></i> START RENDER
		</span>
		<span class="button" (click)="stopRender()" [title]="'STOP_RENDERING' | translate">
			<i class="fa fa-stop"></i> STOP RENDER
		</span>
		
		<span class="button" (click)="getRenderStatus()" [title]="'GET_RENDER_STATUS' | translate">
			<i class="fa fa-question-circle"></i> GET RENDER STATUS
		</span>
		
		<span class="button" (click)="resetRender()" [title]="'RESET_ALL_JOBS' | translate">
			<i class="fa fa-repeat"></i> RESET ALL
		</span>
	</div>

	<div class="table-wrapper">
		<bb-table-container [class.loading]="datafeedService?.loadingRowData" class="datagrid" *ngIf="datafeed && datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport' && datafeed.columns">
			<bb-table-header (click)="log(datafeed.columns)">
				<bb-table-header-cell>#</bb-table-header-cell>
				<ng-container *ngFor="let column of datafeed.columns; let i = index;">
					<bb-table-header-cell class="add-column-cell" *ngIf="datafeed.useConditions && (!datafeed.columns[i - 1] || datafeed.columns[i - 1].headerType === 'condition') && column.headerType === 'value'">
						<div class="add-cell">
							<bb-select [(ngModel)]="addConditionOption" [ngModelOptions]="{standalone: true}" (optionSelected)="addColumn('condition', $event, i)">
								<option value="" selected>+ IF</option>
								<option value="string">{{ 'STRING' | translate }}</option>
								<option value="text">{{ 'TEXT' | translate }}</option>
								<option value="number">{{ 'NUMBER' | translate }}</option>
								<option value="boolean">{{ 'BOOLEAN' | translate }}</option>
								<option value="playout">{{ 'PLAYOUT' | translate }}</option>
								<option value="mediaclip">{{ 'MEDIACLIP' | translate }}</option>
							</bb-select>
						</div>
					</bb-table-header-cell>
					<bb-table-header-cell *ngIf="datafeed.useConditions || column.headerType !== 'condition'">
						<div class="header-text" *ngIf="datafeed.useConditions">
							<span *ngIf="i === 0 && column.headerType === 'condition'">
								IF
							</span>
							<span *ngIf="i > 0 && column.headerType === 'condition'">
								and
							</span>
							<span *ngIf="datafeed.columns[i - 1] && datafeed.columns[i - 1].headerType === 'condition' && column.headerType === 'value'">
								THEN
							</span>
							&nbsp;
						</div>
						<div class="header-label-wrapper">
							<!-- <input type="text" class="header-label" [(ngModel)]="column.key" [name]="'column-value-' + i" pattern="^[a-z0-9_-]"/> -->
							{{ column.label }} <small>{{ column.key }}</small>
							<span *ngIf="column.headerType !== 'id' && column.headerType !== 'composition'" class="remove-column" (click)="removeColumn(i)"><i class="fa fa-trash"></i></span>
						</div>
					</bb-table-header-cell>
				</ng-container>
				<bb-table-header-cell class="add-column-cell" *ngIf="datafeed.useConditions && !datafeed?.columns?.length || ( datafeed.columns[datafeed?.columns?.length - 1] && datafeed.columns[datafeed?.columns?.length - 1].headerType === 'condition' )">
					<div class="add-cell">
						<bb-select [(ngModel)]="addConditionOption" [ngModelOptions]="{standalone: true}" (optionSelected)="addColumn('condition', $event, 1)">
							<option value="" selected>+ IF</option>
							<option value="string">{{ 'STRING' | translate }}</option>
							<option value="text">{{ 'TEXT' | translate }}</option>
							<option value="number">{{ 'NUMBER' | translate }}</option>
							<option value="boolean">{{ 'BOOLEAN' | translate }}</option>
							<option value="playout">{{ 'PLAYOUT' | translate }}</option>
							<option value="mediaclip">{{ 'MEDIACLIP' | translate }}</option>
						</bb-select>
					</div>
				</bb-table-header-cell>
				<bb-table-header-cell class="add-column-cell">
					<div class="add-cell">
						<bb-select [(ngModel)]="addValueOption" [ngModelOptions]="{standalone: true}" (optionSelected)="addColumn('value', $event, datafeed.columns.length)">
							<option value="" selected>{{ datafeed.useConditions ? '+ THEN' : '+ Column' }}</option>
							<option value="string">{{ 'STRING' | translate }}</option>
							<option value="text">{{ 'TEXT' | translate }}</option>
							<option value="number">{{ 'NUMBER' | translate }}</option>
							<option value="boolean">{{ 'BOOLEAN' | translate }}</option>
							<option value="playout">{{ 'PLAYOUT' | translate }}</option>
							<option value="mediaclip">{{ 'MEDIACLIP' | translate }}</option>
						</bb-select>
						<span class="configure-fields" (click)="onConfigureClick()"><i class="fa fa-cog"></i></span>
					</div>
				</bb-table-header-cell>
				<ng-container *ngIf="datafeed.feedType === 'renderedVideo'">
					<bb-table-header-cell class="add-column-cell">
						<div class="render-status">
							{{ 'STATUS' | translate }}
						</div>
					</bb-table-header-cell>
				</ng-container>
			</bb-table-header>
			<ng-container *ngFor="let row of datafeedRows; let rowIndex = index; trackBy: rowTrackBy">
				<bb-table-row *ngIf="rowIndex < amountRows || newRows[rowIndex]"
					[row]="row"
					[class.new-row]="newRows[rowIndex] && !datafeed?.storageMode"
					[class.is-dirty]="dirtyRows[row?.id]"
					(dblclick)="editRow(rowIndex);"
				>
					<ng-container>
						<bb-table-cell (click)="editRow(rowIndex); log(datafeedRows[rowIndex]);" [title]="'EDIT' | translate" class="edit-row-cell">
							<span class="nr">
								{{ rowIndex + 1 }}
							</span>
							<span class="edit-btn">
								<i class="fa fa-pencil"></i>
							</span>
						</bb-table-cell>
					</ng-container>
					<ng-container *ngFor="let column of datafeed.columns; let i = index;">
						<bb-table-cell class="add-column-cell" *ngIf="datafeed.useConditions && ( !datafeed.columns[i - 1] || datafeed.columns[i - 1].headerType === 'condition' ) && column.headerType === 'value'">
							<div class="cell-inner">
							</div>
						</bb-table-cell>
						<bb-table-cell *ngIf="datafeed.useConditions || column.headerType !== 'condition'">
							<div class="cell-inner" [class.disabled]="column.headerType === 'id'">
								<ng-container 
									*ngIf="fieldConfigs[column.dataType] && datafeedRows[rowIndex] && column.key"
								>
									<bb-select
										*ngIf="column.headerType === 'condition' && fieldConfigs[column.dataType] && fieldConfigs[column.dataType].type && operatorOptions[fieldConfigs[column.dataType].type] && ! isObj( datafeedRows[rowIndex][column.key] )"
										[defaultValue]="'is'"
										[options]="operatorOptions[fieldConfigs[column.dataType].type]"
										(optionSelected)="onOperatorSelected(datafeedRows[rowIndex], column.key, $event)"
									></bb-select>
									<bb-select
										*ngIf="column.headerType === 'condition' && fieldConfigs[column.dataType] && fieldConfigs[column.dataType].type && operatorOptions[fieldConfigs[column.dataType].type] && isObj( datafeedRows[rowIndex][column.key] )"
										[(ngModel)]="datafeedRows[rowIndex][column.key].operator"
										[options]="operatorOptions[fieldConfigs[column.dataType].type]"
										(optionSelected)="onOperatorSelected(datafeedRows[rowIndex], column.key, $event)"
									></bb-select>
	
									<bb-field-renderer
										*ngIf="(
											datafeedRows[rowIndex][column.key] &&
											datafeedRows[rowIndex][column.key].operator !== 'undefined' &&
											datafeedRows[rowIndex][column.key].operator !== 'defined') &&
											(
												datafeedRows[rowIndex][column.key] &&
												(
													datafeedRows[rowIndex][column.key].value ||
													datafeedRows[rowIndex][column.key].value === '' ||
													datafeedRows[rowIndex][column.key].value === 0 ||
													datafeedRows[rowIndex][column.key].value === null
												)
											)"
										[(ngModel)]="datafeedRows[rowIndex][column.key].value"
										[fieldConfig]="fieldConfigs[column.dataType]"
										(ngModelChange)="datafeedChanged(datafeed, row)"
									></bb-field-renderer>
	
									<ng-container *ngIf="column.headerType === 'composition'">
										<input matInput [matAutocomplete]="rowCompositionToRenderAuto" type="text" name="row-composition-to-render" [(ngModel)]="datafeedRows[rowIndex][column.key]" 
											(ngModelChange)="datafeedChanged(datafeed, row)" />
										<mat-autocomplete #rowCompositionToRenderAuto="matAutocomplete" (ngModelChange)="datafeedChanged(datafeed, row)">
											<mat-option *ngFor="let option of aeProject.compositionOptions" [value]="option.value">{{option.label}}</mat-option>
										</mat-autocomplete>
									</ng-container>
								
									<bb-field-renderer
										class="thisone"
										*ngIf="column.headerType !== 'composition' && (!datafeedRows[rowIndex][column.key] || datafeedRows[rowIndex][column.key].value === undefined)"
										[(ngModel)]="datafeedRows[rowIndex][column.key]"
										[fieldConfig]="fieldConfigs[column.dataType]"
										[displayInline]="true"
										(ngModelChange)="datafeedChanged(datafeed, row)"
									></bb-field-renderer>
								</ng-container>
							</div>
						</bb-table-cell>
					</ng-container>
					<ng-container *ngIf="datafeed.useConditions && (!datafeed?.columns?.length || ( datafeed.columns[datafeed?.columns?.length - 1] && datafeed.columns[datafeed?.columns?.length - 1].headerType === 'condition' ))">
						<bb-table-cell class="add-column-cell">
							<div class="cell-inner">
							</div>
						</bb-table-cell>
					</ng-container>
					<ng-container>
						<bb-table-cell class="add-column-cell buttons">
							<div class="cell-inner">
								<span class="button" (click)="duplicateRow(row, rowIndex)" [title]="'DUPLICATE_ROW' | translate">
									<i class="fa fa-copy"></i>
								</span>
								<bb-button [disabled]="!dirtyRows[row?.id]" *ngIf="datafeed?.storageMode === 's3'" (click)="updateRow(row, rowIndex)" [title]="'UPDATE_ROW' | translate">
									<i class="fa fa-floppy-disk"></i>
								</bb-button>
								<span class="button" (click)="deleteRow(row, rowIndex)" [title]="'DELETE_ROW' | translate">
									<i class="fa fa-trash"></i>
								</span>
	
								<ng-container *ngIf="datafeed.feedType === 'renderedVideo' && datafeed.dynamicMediaclip">
									<span *ngIf="!renderJobs[row.id] || renderJobs[row.id].status === 'new'" class="button" (click)="updateRenderJob('queue', row)" [title]="'QUEUE_RENDER_JOB' | translate">
										<i class="fa fa-list-alt"></i>
									</span>
									<span *ngIf="renderJobs[row.id]?.status === 'queued'" class="button" (click)="updateRenderJob('stop', row)" [title]="'STOP_RENDERING' | translate">
										<i class="fa fa-stop"></i>
									</span>
									<span *ngIf="renderJobs[row.id]?.status === 'finished' || renderJobs[row.id]?.status === 'error'" class="button" (click)="updateRenderJob('reset', row)" [title]="'RESET_RENDER_JOB' | translate">
										<i class="fa fa-repeat"></i>
									</span>
									<a *ngIf="renderJobs[row.id]?.status === 'finished' && datafeed.dynamicMediaclip && row.id"
										[href]="'https://' + baseurl + '/p/default/d/' + datafeed.dynamicMediaclip + '.html?dvid=' + row.id"
										[title]="'PREVIEW_RENDERED_VIDEO' | translate"
										target="_blank"
										class="button"
									>
										<i class="fa fa-external-link"></i>
									</a>
								</ng-container>
							</div>
						</bb-table-cell>
					</ng-container>
					<ng-container *ngIf="datafeed.feedType === 'renderedVideo'">
						<bb-table-cell>
							<div class="cell-inner">
								{{ renderJobs[row.id]?.status }}
								<bb-info style="padding: 1px 5px;" *ngIf="renderJobs[row.id]" [contents]="'<pre>' + (renderJobs[row.id] | json) + '</pre>'" [icon]="'info'"></bb-info>
							</div>
						</bb-table-cell>
					</ng-container>
				</bb-table-row>
			</ng-container>
		</bb-table-container>
		<bb-loading *ngIf="datafeedService?.loadingRowData"></bb-loading>
	</div>
	<div *ngIf="!datafeedService?.loadingRowData" class="button-row">
		<div *ngIf="datafeed?.storageMode === 's3' && datafeedService?.nextContinuationToken" class="load-more-rows button" (click)="loadMoreRows()">{{ 'LOAD_MORE_ROWS' | translate }}</div>
		<div *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport'" class="add-row button" (click)="addRow()">{{ 'ADD_ROW' | translate }}</div>
		<div
			*ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport'"
			[ngClass]="{'disabled': !datafeedRows.length}"
			class="add-row button"
			(click)="deleteAllRows()"
		>
			<i class="fa fa-trash"></i>
			{{ 'CLEAR_ALL_ROWS' | translate }}
		</div>
		<div class="clearable-input" *ngIf="datafeed?.storageMode === 's3'">
			<input type="text" [(ngModel)]="rowStoreIdSearch" name="rowStoreIdSearch" (change)="onSingleRowIdChange(rowStoreIdSearch)" [placeholder]="'FETCH_ROW_BY_ID' | translate" />
			<div class="close-button" [hidden]="!rowStoreIdSearch">
				<i class="fa fa-times close-icon" (click)="rowStoreIdSearch = ''; onSingleRowIdChange(rowStoreIdSearch)"></i>
			</div>
		</div>
		<div *ngIf="datafeed.feedType !== 'rssFeedImport' && datafeed.feedType !== 'xmlUploadImport' && datafeed?.rows?.length" class="show-rows"> Showing 1 - {{ amountRows > datafeedRows.length ? datafeedRows.length : amountRows }} of {{ datafeedService?.externalRowCount || datafeedRows.length }} rows <a class="show-more" (click)="amountRows = amountRows * 2" *ngIf="amountRows < datafeed?.rows?.length"> | {{ 'SHOW_MORE' | translate }}</a></div>
	</div>

	<div class="edit-row-container" *ngIf="rowEditIndex || rowEditIndex === 0" (click)="closeEditRow()">
		<div class="edit-row-form" (click)="$event.stopPropagation()">
			<h2 (click)="log(datafeedRows[rowEditIndex])">Edit row #{{ rowEditIndex + 1 }}</h2>
			<bb-form-element *ngFor="let column of datafeed.columns; let i = index;" [label]="column.label">
				<div class="add-column-cell" *ngIf="datafeed.useConditions && ( !datafeed.columns[i - 1] || datafeed.columns[i - 1].headerType === 'condition' ) && column.headerType === 'value'">
					<div class="cell-inner">
					</div>
				</div>
				<div *ngIf="datafeed.useConditions || column.headerType !== 'condition'">
					<div class="cell-inner" [class.disabled]="column.headerType === 'id'">
						<ng-container 
							*ngIf="fieldConfigs[column.dataType] && datafeedRows[rowEditIndex] && column.key"
						>
							<bb-select
								*ngIf="column.headerType === 'condition' && fieldConfigs[column.dataType] && fieldConfigs[column.dataType].type && operatorOptions[fieldConfigs[column.dataType].type] && ! isObj( datafeedRows[rowEditIndex][column.key] )"
								[defaultValue]="'is'"
								[options]="operatorOptions[fieldConfigs[column.dataType].type]"
								(optionSelected)="onOperatorSelected(datafeedRows[rowEditIndex], column.key, $event)"
								(ngModelChange)="datafeedChanged(datafeed, datafeedRows[rowEditIndex])"
							></bb-select>
							<bb-select
								*ngIf="column.headerType === 'condition' && fieldConfigs[column.dataType] && fieldConfigs[column.dataType].type && operatorOptions[fieldConfigs[column.dataType].type] && isObj( datafeedRows[rowEditIndex][column.key] )"
								[(ngModel)]="datafeedRows[rowEditIndex][column.key].operator"
								[options]="operatorOptions[fieldConfigs[column.dataType].type]"
								(optionSelected)="onOperatorSelected(datafeedRows[rowEditIndex], column.key, $event)"
								(ngModelChange)="datafeedChanged(datafeed, datafeedRows[rowEditIndex])"
							></bb-select>

							<div>
								<bb-field-renderer
									*ngIf="(
										datafeedRows[rowEditIndex][column.key] &&
										datafeedRows[rowEditIndex][column.key].operator !== 'undefined' &&
										datafeedRows[rowEditIndex][column.key].operator !== 'defined') &&
										(
											datafeedRows[rowEditIndex][column.key] &&
											(
												datafeedRows[rowEditIndex][column.key].value ||
												datafeedRows[rowEditIndex][column.key].value === '' ||
												datafeedRows[rowEditIndex][column.key].value === 0 ||
												datafeedRows[rowEditIndex][column.key].value === null
											)
										)"
									[(ngModel)]="datafeedRows[rowEditIndex][column.key].value"
									[fieldConfig]="fieldConfigs[column.dataType]"
									(ngModelChange)="datafeedChanged(datafeed, datafeedRows[rowEditIndex])"
								></bb-field-renderer>
							
								<ng-container *ngIf="column.headerType === 'composition'">
									<input class="edit-row-comp-autocomplete" matInput [matAutocomplete]="editRowCompositionToRenderAuto" type="text" name="row-composition-to-render" [(ngModel)]="datafeedRows[rowEditIndex][column.key]" (ngModelChange)="datafeedChanged(datafeed, datafeedRows[rowEditIndex])"/>
									<mat-autocomplete #editRowCompositionToRenderAuto="matAutocomplete">
										<mat-option *ngFor="let option of aeProject.compositionOptions" [value]="option.value">{{option.label}}</mat-option>
									</mat-autocomplete>
								</ng-container>
							
								<bb-field-renderer
									*ngIf="column.headerType !== 'composition' && (!datafeedRows[rowEditIndex][column.key] || datafeedRows[rowEditIndex][column.key].value === undefined)"
									[(ngModel)]="datafeedRows[rowEditIndex][column.key]"
									[fieldConfig]="fieldConfigs[column.dataType]"
									[displayInline]="true"
									(ngModelChange)="datafeedChanged(datafeed, datafeedRows[rowEditIndex])"
								></bb-field-renderer>
							</div>
						</ng-container>
					</div>
				</div>
			</bb-form-element>
			<div class="done">
				<bb-button (click)="closeEditRow(datafeedRows[rowEditIndex])">
					Done
				</bb-button>
			</div>
		</div>
	</div>

	<div class="imported-clips-wrapper">
		<ng-container *ngIf="(datafeed?.feedType === 'rssFeedImport' || datafeed?.feedType === 'xmlUploadImport') && relatedMediaclips?.length">
			<h3>
				{{ 'LATEST_IMPORTED_MEDIACLIPS' | translate }}
			</h3>
			<a [routerLink]="['/library/mediaclips']" [queryParams]="{q: 'Datafeed' + datafeed?.id }">{{ 'VIEW_ALL_IMPORTED_CLIPS' | translate }}</a>
			<bb-table-container>

				<bb-table-header>
					<bb-table-header-cell class="thumb"></bb-table-header-cell>
					<bb-table-header-cell class="icon"></bb-table-header-cell>
					<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="length">{{ 'LENGTH' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="views">{{ 'VIEWS' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="status" class="icon" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}">&nbsp;</bb-table-header-cell>
					<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
					<bb-table-header-cell property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
					<bb-table-header-cell class="buttons"></bb-table-header-cell>
				</bb-table-header>
		
				<bb-table-row *ngFor="let row of relatedMediaclips" [row]="row">
					<bb-table-cell class="thumb">
						<div class="thumbnail-wrapper" [attr.title]="row?.transcodingAverage < 1? ('TRANSCODING_STATUS' | translate) + (row?.transcodingAverage > 0 ? (row?.transcodingAverage | percentage: 0) : 'queued') : ''">
							<span *ngIf="row?.transcodingAverage < 1" class="transcoding-progress">{{ row?.transcodingAverage | percentage: 0 }}</span>
							<div *ngIf="row?.transcodingAverage < 1" class="thumbnail-overlay"></div>
		
							<span [innerHTML]="row | thumbnail : 50:28:null:row?.transcodingAverage < 1 | async"></span>
						</div>
					</bb-table-cell>
					<bb-table-cell><span style="white-space: no-break;"><span [innerHTML]="row | clipIcon"></span><strong [hidden]="row.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;" title="Creative">C</strong></span></bb-table-cell>
					<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
					<bb-table-cell property="title" class="overflow">
						<span [hidden]="!row.title">{{ row.title }}</span>
						<span [hidden]="row.title" class="filename">{{ row.originalfilename }}</span>
						
					</bb-table-cell>
					<bb-table-cell property="length">{{ row.length | seconds }}</bb-table-cell>
					<bb-table-cell property="views">{{ row.views }}</bb-table-cell>
					<bb-table-cell property="status" *ngIf="row?.data?.sourceid?.startsWith('live_api_')" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span [innerHTML]="(row | statusIcon) + (row | bbStreamStatusIcon | async)" class="stream-status-icon"></span></bb-table-cell>
					<bb-table-cell property="status" *ngIf="!row?.data?.sourceid?.startsWith('live_api_')" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span [innerHTML]="row | statusIcon"></span></bb-table-cell>
					<bb-table-cell property="createddate" class="date" [titleValue]="row.createddate | bbDate">{{ row.createddate | bbDate:'relative' }}</bb-table-cell>
					<bb-table-cell property="updateddate" class="date" [titleValue]="row.updateddate | bbDate">{{ row.updateddate | bbDate:'relative' }}</bb-table-cell>
					<bb-table-cell class="buttons">
		
						<a class="button" [routerLink]="['/library/mediaclip/', row.id, 'metadata']">
							<i class="fa fa-edit"></i>
						</a><!--
		
						--><a class="button" [routerLink]="['/analytics/statistics/', row.id]">
							<i class="fa fa-line-chart"></i>
						</a>
					</bb-table-cell>
				</bb-table-row>
		
			</bb-table-container>
		</ng-container>
	</div>
</div>
